import { Location } from 'history'
import { matchPath } from 'react-router'
import {
  accountsUrl,
  expensesTransactionsUrl,
  homeUrl,
  virtualCardsUrl,
} from 'src/navigation/urls'
import { LocationState } from 'src/redux/createRootReducer'

export const handlePageLocation = (
  calculatedBackgroundLocation: Location<LocationState>,
): string => {
  return matchPath(calculatedBackgroundLocation.pathname, homeUrl())
    ? 'home'
    : matchPath(
          calculatedBackgroundLocation.pathname,
          expensesTransactionsUrl(),
        )
      ? 'transactions'
      : matchPath(calculatedBackgroundLocation.pathname, virtualCardsUrl())
        ? 'virtual cards'
        : matchPath(calculatedBackgroundLocation.pathname, accountsUrl())
          ? 'accounts'
          : ''
}
